import { DATA } from '@wix/component-protocol/schema';

export { ACTION_NAME_TO_DATA_TYPE } from './types';

export const AUTOPANELS_DATA_TYPES_BLACKLIST: (keyof typeof DATA.DATA_TYPE)[] =
  [DATA.DATA_TYPE.text, DATA.DATA_TYPE.vectorArt];
